import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { components } from "@/shared/lib/api.types";
import { api, unwrap } from "@/shared/lib/apiClient";
import type { LoginValues } from "../auth.schemas";
import { authKeys } from "./auth.queries";

type RegisterRequest = components["schemas"]["RegisterRequest"];

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: LoginValues) =>
      unwrap(await api.POST("/api/auth/login", { body })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: authKeys.me }),
  });
}

// The backend creates the user as an Applicant and signs them in.
export function useJoin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: RegisterRequest) =>
      unwrap(await api.POST("/api/auth/register", { body })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: authKeys.me }),
  });
}

export function useLogout() {
  // No cache side effects here: the caller navigates away before clearing `me`, else a 401 flashes. See useLogoutFlow.
  return useMutation({
    mutationFn: async () => {
      unwrap(await api.POST("/api/auth/logout"));
    },
  });
}
